import { Row } from "@tanstack/react-table";

import { EditConnectionModal } from "../edit";
import { IQueryConnection } from "@/@types/query-connections";
import { Button } from "components/ui/button";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const { handleModal } = useDialogModal();

  const editConnection = () => {
    handleModal({
      isOpen: true,
      element: (
        <EditConnectionModal connection={row.original as IQueryConnection} />
      ),
      title: "Editar Conexão",
      description: " Faça alterações na sua conexão de banco de dados aqui. Clique em salvar quando você terminar.",
    });
  };
  return (
    <div className="flex items-center justify-center">
      <Button
        className="flex px-4 p-0 data-[state=open]:bg-muted border-none bg-transparent hover:bg-black/0 underline text-[#5577B9] hover:text-[#5577B9]/60 text-sm font-normal"
        onClick={editConnection}
      >
        Editar
      </Button>
    </div>
  );
}
